import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withTheme, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
// Custom
import { getHocDisplayName } from 'utils/Tools';

// Local themes
const localThemes = () => ({
  success: {
    palette: {
      primary: {
        ...green,
        contrastText: '#FFF',
      },
    },
  },
  warning: {
    palette: {
      primary: {
        ...orange,
        contrastText: '#FFF',
      },
    },
  },
  contrasted: {
    palette: {
      primary: {
        main: grey[50],
      },
    },
  },
  sidebar: {
    overrides: {
      MuiDivider: {
        root: {
          backgroundColor: '#A1A1A1',
        },
      },
      MuiDrawer: {
        paper: {
          backgroundColor: '#1F242C',
        },
      },
      MuiListItem: {
        root: {
          color: '#A1A1A1',
          '&:hover': {
            color: '#CCC',
          },
          '&$selected': {
            color: '#FAFAFA',
            backgroundColor: 'rgba(0, 0, 0, 0.24)',
          },
          height: '45px',
        },
        button: {
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
      MuiListItemIcon: {
        root: {
          minWidth: '48px',
        },
      },
      MuiTypography: {
        body1: {
          fontSize: '14px',
        },
        colorInherit: {
          color: '#FAFAFA',
        },
      },
      MuiSvgIcon: {
        root: {
          width: '20px',
          height: '20px',
        },
        colorPrimary: {
          color: '#A1A1A1',
        },
        colorSecondary: {
          color: '#FAFAFA',
        },
      },
    },
  },
});

const withLocalTheme = (WrappedComponent) => {
  const WithLocalTheme = ({ theme, context, ...otherProps }) => {
    // Get theme
    const localTheme = localThemes()[context];

    if (localTheme) {
      return (
        <MuiThemeProvider theme={createMuiTheme({ ...theme, ...localTheme })}>
          <WrappedComponent {...otherProps} />
        </MuiThemeProvider>
      );
    }

    return (<WrappedComponent {...otherProps} />);
  };

  WithLocalTheme.displayName = getHocDisplayName('WithLocalTheme', WrappedComponent);

  WithLocalTheme.propTypes = {
    theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    context: PropTypes.string,
  };

  WithLocalTheme.defaultProps = {
    context: null,
  };

  return withTheme(WithLocalTheme);
};

export default withLocalTheme;



// WEBPACK FOOTER //
// ./components/core/hocs/WithLocalTheme.js